import { AbstractControl, ValidatorFn } from '@angular/forms';

export class CustomValidators {
  constructor() {}

  static mustMatch(controlName: string, matchingControlName: string) {
    return (control: AbstractControl) => {
      // @ts-ignore
      let control1 = control.controls[controlName];
      // @ts-ignore
      let matchingControl = control.controls[matchingControlName];

      if(matchingControl.errors && !matchingControl.errors.mustMatch) {
        return null;
      }

      // set error on matchingControl if validation fails
      if (control1.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
      return null;
    }
  }
}
